import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { serverAddr } from "@/networkConfig";

Vue.use(Vuex);

function initialState() {
  return {
    selected_broker: null, // Use null instead of empty object for clarity
  };
}

export default new Vuex.Store({
  state: initialState(),

  mutations: {
    commitSelectedBroker(state, payload) {
      state.selected_broker = payload;
    },
    commitBrokerList(state, payload) {
      state.broker_list = payload;
    },

    // to reset all state to its initial state
    resetAllState(state) {
      const s = initialState();
      Object.keys(s).forEach((key) => {
        state[key] = s[key];
      });
    },
  },
  plugins: [createPersistedState()],
  actions: {
    someAction({ commit, state }, payload) { // Access state from context
      // Perform action
      console.log(payload);
      serverAddr
        .get("/auth/admin/v1/client_list")
        .then((response) => {
          if (response.data.status) {
            var brokerList = response.data.data;
            commit("commitBrokerList", brokerList);
            console.log(state);
            if (!state.selected_broker) {
              const selectedBroker = brokerList[0];
              commit("commitSelectedBroker", selectedBroker);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
});
